"use client";

import { usePathname } from "next/navigation";
import Script from "next/script";
import { useEffect, useState } from "react";
import { env } from "@/common/env/client.mjs";
import { isNull } from "@/common/helpers/lang";

import { pageView } from "./page-view";

export function GoogleTagManager() {
  const pathname = usePathname();
  const [isUserInteraction, setIsUserInteraction] = useState(false);
  const { NEXT_PUBLIC_GTAG_ID } = env;

  useEffect(() => {
    const handleUserInteraction = () => {
      if (window.isUserInteraction) return;
      window.isUserInteraction = true;
      setIsUserInteraction(true);
    };

    window.addEventListener("click", handleUserInteraction, { once: true });
    window.addEventListener("scroll", handleUserInteraction, { once: true });
    window.addEventListener("keydown", handleUserInteraction, { once: true });
    window.addEventListener("touchstart", handleUserInteraction, { once: true });
    window.addEventListener("mousemove", handleUserInteraction, { once: true });

    return () => {
      window.removeEventListener("click", handleUserInteraction);
      window.removeEventListener("scroll", handleUserInteraction);
      window.removeEventListener("keydown", handleUserInteraction);
      window.removeEventListener("touchstart", handleUserInteraction);
      window.removeEventListener("mousemove", handleUserInteraction);
    };
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: pageView should invoke on every path change
  useEffect(() => {
    pageView();
  }, [pathname]);

  if (isNull(NEXT_PUBLIC_GTAG_ID) || !isUserInteraction) {
    return null;
  }

  return (
    <Script id="gtag-script" strategy="lazyOnload">
      {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${NEXT_PUBLIC_GTAG_ID}');
      `}
    </Script>
  );
}
